module.exports = __webpack_public_path__ + "media/images/noticias/placeholdertres-9c1c38467b2e61edce0a04d8bd4a7608.jpg";